import Booking from "./Booking";
import Testimonials from "./Testimonials";
export default function About() {
    return (
      <>
        <section className="inner-banner-area rooms-hero">
          <img src="img/room-hero-banner.avif" className="w-100" />
          <div className="container">
            <div className="contact-banner">
              <div className="text-center">
                <h2 className="inner-banner-heading">About</h2>
                <nav aria-label="breadcrumb" className="banner-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="index.php">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">About Us</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>

        <Booking></Booking>


    


<section className="home-about pb-5">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="h-about-left">
              <h6 className="top-sub-title">A Brand New Hotel</h6>
              <h1 className="about-title">Welcome to the The Grand New Delhi</h1>
              
            </div>
          </div>
          <div className="col-md-12">
            <div className="about-right-content mt-4">
              <h6 className="right-sub-title">An Immersive Experience in The Heart of New Delhi</h6>
              <p>The Grand New Delhi Hotel has served spontaneously to its customers since the time of its inception. With an area spanning 10 acres and a location close enough to the airport makes it a glamorous wonder. It not only maintains the luxury hotel tag but does it so flawlessly that you come and stay, again and again. The hotel stands near to the Indira Gandhi International Airport and various luxury shopping malls like DLF Promenade, Ambience Mall and DLF Emporia. The Hotel Possesses around 390 well furnished, luxurious rooms that reflect of rigid supremacy.  </p>
              <p>It has the best of spas and the finest of restaurants specifically to enhance your comfort and add to the luxury you carry at The Grand New Delhi Hotel. There’s a strategy for its fine location near the dense green belt with various commercial establishments and government offices. This strategical placement advocate for it connecting the heart of the city with its commerce. </p>  
              <p>The Architectural intellect behind the hotel's build was developed by Skidmore, Owings and Merrill of London and Rajinder Kumar & Associates of Delhi. The courtesy of its well-built and enticing interior goes to the renowned Hirsch Bedner and Associates of San Francisco. The interior absolves itself with a touch of traditional Indian design with the safest architecture. The hotel chaperones an amazing lobby, one of its essential trademarks, with a beautiful blend of rich pinewood and black marble and a stunning ceiling with natural skylights. It has large full window frontages that present to you beautiful green gardens once you lean on.</p>               
            </div>
          </div>

            <div className="col-md-12 about-img-gallery">
              <div className="hero-right">
                  <div className="hero-left">
                      <img src="img/about-gal-1.webp" alt="" />
                  </div>
                  <div className="hero-right-inner-main">
                      <div className="hero-right-inner">
                          <img src="img/about-gal-2.webp" alt="" />
                          <img src="img/about-gal-3.webp" alt="" />
                      </div>
                      <div className="hero-right-inner hero-right-inner-last">
                          <img src="img/about-gal-4.webp" alt="" />
                          <img src="img/about-gal-5.webp" alt="" />
                      </div>
                  </div>
          
              </div>
          </div>

           
          </div>
        </div>
      </section>
      <Testimonials></Testimonials>

      </>
    );
  }
  